import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BuildIcon from '@mui/icons-material/Build';
import HistoryIcon from '@mui/icons-material/History';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PersonIcon from '@mui/icons-material/Person';
import { Avatar, Box, Container, Stack, Typography } from "@mui/material";
import { useAppSelector } from "helpers/hooks";
import { ShMuiLink } from 'shared/SharedStyles/ShNavigation';
import { ShPaper } from 'shared/SharedStyles/ShSurfaces';
import { PrimaryThemeColor } from "shared/SharedStyles/styleConstants";

export const CandidateHome = () => {

    const { firstName } = useAppSelector(state => state.auth.auth);

    return (<>
        <Container maxWidth='sm'>
            <Stack padding={{ xs: 1, sm: 2, md: 3, lg: 4 }} direction='row' alignItems='center' columnGap={1}>
                <Avatar>{firstName ? firstName[0] : <PersonIcon />}</Avatar>
                <Typography variant="h4">Welcome back,</Typography>
                <Typography variant="h4" color={PrimaryThemeColor}>{firstName}</Typography>
            </Stack>
            <Box padding={{ xs: 1, sm: 2, md: 3, lg: 4 }}>
                <Typography variant='h6' color={PrimaryThemeColor} gutterBottom>Career Seeker Resources</Typography>
                <Stack rowGap={1}>
                    <ShPaper variant='outlined' elevationOnHover cursor='pointer'>
                        <ShMuiLink href='/candidate/report' noUnderline color='inherit'>
                            <Stack direction='row' alignItems='center' width='100%' columnGap={1}>
                                <AssessmentIcon color='success' fontSize='large' />
                                <Box>
                                    <Typography variant='body1'>Personal Career report</Typography>
                                    <Typography variant='caption'>Learn about your unique traits</Typography>
                                </Box>
                            </Stack>
                        </ShMuiLink>
                    </ShPaper>
                    <ShPaper variant='outlined' elevationOnHover cursor='pointer'>
                        <ShMuiLink href='/candidate/career-tools' noUnderline color='inherit'>
                            <Stack direction='row' alignItems='center' width='100%' columnGap={1}>
                                <BuildIcon color='success' fontSize='large' />
                                <Box>
                                    <Typography variant='body1'>Career tools</Typography>
                                    <Typography variant='caption'>Learn which career you're best suited for</Typography>
                                </Box>
                            </Stack>
                        </ShMuiLink>
                    </ShPaper>
                    <ShPaper variant='outlined' elevationOnHover cursor='pointer'>
                        <ShMuiLink href='/candidate/settings' noUnderline color='inherit'>
                            <Stack direction='row' columnGap={1} alignItems='center'>
                                <NotificationsIcon color='success' fontSize='large' />
                                <Box>
                                    <Typography variant='body1'>Job notification settings</Typography>
                                    <Typography variant='caption'>Update job notification settings</Typography>
                                </Box>
                            </Stack>
                        </ShMuiLink>
                    </ShPaper>
                    <ShPaper variant='outlined' elevationOnHover cursor='pointer'>
                        <ShMuiLink href='/candidate/profile' noUnderline color='inherit'>
                            <Stack direction='row' columnGap={1} alignItems='center'>
                                <AccountCircleIcon color='success' fontSize='large' />
                                <Box>
                                    <Typography variant='body1'>Your Smoothhiring profile</Typography>
                                    <Typography variant='caption'>Update your email and password</Typography>
                                </Box>
                            </Stack>
                        </ShMuiLink>
                    </ShPaper>
                    <ShPaper variant='outlined' elevationOnHover cursor='pointer'>
                        <ShMuiLink href='/candidate/history' noUnderline color='inherit'>
                            <Stack direction='row' columnGap={1} alignItems='center'>
                                <HistoryIcon color='success' fontSize='large' />
                                <Box>
                                    <Typography variant='body1'>Candidate history</Typography>
                                    <Typography variant='caption'>View your job application history</Typography>
                                </Box>
                            </Stack>
                        </ShMuiLink>
                    </ShPaper>
                </Stack>
            </Box>
        </Container>
    </>)
}